// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"fbfa455b","703":"801b1051"}[chunkId] + ".chunk.js";
};